import { Navigate, Route, Routes } from 'react-router-dom';
import { FollowProvider } from './contexts/FollowContext';
import { useAuth } from './hooks/useAuth';

// Styles pour le layout mobile avec menu en bas
import './styles/MobileLayout.css';

// Pages
import Admin from './pages/Admin';
import Chat from './pages/Chat';
import CreatePost from './pages/CreatePost';
import EditProfile from './pages/EditProfile';
import HashtagDetail from './pages/HashtagDetail';
import Home from './pages/Home';
import Login from './pages/Login';
import PostDetail from './pages/PostDetail';
import Profile from './pages/Profile';
import Register from './pages/Register';
import Search from './pages/Search';
import UserManagement from './pages/UserManagement';
import Welcome from './pages/Welcome';

// Components
import BackToTop from './components/BackToTop';
import BottomNavbar from './components/BottomNavbar';
import LoadingSpinner from './components/LoadingSpinner';
import ProtectedRoute from './components/ProtectedRoute';
import TopMenu from './components/TopMenu';

function App() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullScreen={true} text="Chargement de l'application..." size="large" />;
  }

  return (
    <FollowProvider>
      <div className="app app-container">
        <TopMenu />
        <BackToTop
          threshold={120}
          position="top-right"
          anchorSelector=".feed-mode .feed-header"
          anchorSpacing={8}
        />
        <main className="main-content scrollable-content">
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/index.html" element={<Navigate to="/home" replace />} />
            <Route path="/social-app" element={<Navigate to="/home" replace />} />
            <Route path="/social-app/" element={<Navigate to="/home" replace />} />
            <Route path="/social-app/index.html" element={<Navigate to="/home" replace />} />
            <Route path="/src/social-app" element={<Navigate to="/home" replace />} />
            <Route path="/src/social-app/" element={<Navigate to="/home" replace />} />
            <Route path="/src/social-app/index.html" element={<Navigate to="/home" replace />} />
            <Route path="/login" element={currentUser ? <Navigate to="/home" replace /> : <Login />} />
            <Route path="/register" element={currentUser ? <Navigate to="/home" replace /> : <Register />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/home" element={<Home />} />
            <Route path="/edit-profile" element={
              <ProtectedRoute>
                <EditProfile />
              </ProtectedRoute>
            } />
            <Route path="/profile/edit" element={<Navigate to="/edit-profile" replace />} />
            <Route path="/profile/:username" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/user/:username/post/:postId" element={
              <ProtectedRoute>
                <PostDetail />
              </ProtectedRoute>
            } />
            <Route path="/create" element={
              <ProtectedRoute>
                <CreatePost />
              </ProtectedRoute>
            } />
            <Route path="/edit-post/:id" element={
              <ProtectedRoute>
                <CreatePost />
              </ProtectedRoute>
            } />
            <Route path="/chat" element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            } />
            <Route path="/search" element={<Search />} />
            <Route path="/explore/hashtag/:hashtag" element={<HashtagDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </main>
        <BottomNavbar />
      </div>
    </FollowProvider>
  );
}

export default App;
